export default {"src":"/_next/static/image/public/images/edit_blue.b5ea3863392c2c2d9e36f205e3128e38.svg","height":18,"width":18};